<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div [id]="theId"
     class="slds-form-element">
  <div *ngIf="showClock" class="slds-grid">
    <div class="slds-col">
      <svg [attr.height]="size"
           [attr.width]="size"
           viewBox="0 0 1024 1024"
           x="0"
           y="0">
        <circle [attr.r]="faceRadius"
                [attr.stroke]="faceStroke"
                cx="512"
                cy="512"
                fill="none"
                id="clock-face"
                stroke-width="4"></circle>
        <circle [attr.r]="ssRadius"
                [attr.stroke-dasharray]="ssDisplay"
                [attr.stroke-width]="strokeWidth"
                [attr.stroke]="ssStroke"
                cx="512"
                cy="512"
                fill="none"
                id="clock-sec"
                transform="rotate(270, 512, 512)"></circle>
        <circle [attr.r]="mmRadius"
                [attr.stroke-dasharray]="mmDisplay"
                [attr.stroke-width]="strokeWidth"
                [attr.stroke]="mmStroke"
                cx="512"
                cy="512"
                fill="none"
                id="clock-min"
                transform="rotate(270, 512, 512)"></circle>
        <circle [attr.r]="hhRadius"
                [attr.stroke-dasharray]="hhDisplay"
                [attr.stroke-width]="strokeWidth"
                [attr.stroke]="hhStroke"
                cx="512"
                cy="512"
                fill="none"
                id="clock-hour"
                transform="rotate(270, 512, 512)"></circle>
        <text [attr.fill]="mmStroke"
              [attr.font-size]="fontSize"
              dominant-baseline="middle"
              id="clock-time"
              text-anchor="middle"
              x="512"
              y="512">{{digitalDisplay}}</text>
      </svg>
    </div>
    <div class="slds-col">
      <div *ngIf="showClockHide"
           style="text-align: right;">
        <button (click)="onClickShowHide()"
                class="slds-button">hide timer
        </button>
      </div>
      <div *ngIf="showStart"
           class="slds-m-vertical_small">
        <button (click)="onClickStart()"
                class="slds-button slds-button_success slds-truncate">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
            <use [attr.xlink:href]="buttonIcon"></use>
          </svg>
          {{buttonLabel}}</button>
      </div>
      <div *ngIf="showStop" class="slds-m-vertical_small">
        <button (click)="onClickStop()"
                [disabled]="stopDisabled"
                class="slds-button slds-button_brand">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#stop"></use>
          </svg>
          Stop
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showClockHide && !showClock"
       style="text-align: right;">
    <button (click)="onClickShowHide()"
            class="slds-button">show timer
    </button>
  </div>

  <div *ngIf="!showClockHide && !showClock"
       class="slds-form-element slds-form-element_readonly">
    <span class="slds-form-element__label">{{ label }}</span>
    <div class="slds-form-element__control">
      <div class="slds-form-element__static">{{ valueMinutes }}</div>
    </div>
  </div>
</div>
